/**
 * InspectorDrawer — shadcn Sheet wrapper for the Inspector pane at <1280px.
 *
 * Props:
 *   open         {boolean}            — controls sheet open state
 *   onOpenChange {(open: boolean) => void} — sheet close callback
 *   selected     {InboxItem | null}   — currently selected inbox item
 *   onRefresh    {function=}          — retry/refetch handler, forwarded to
 *     DealInspectorPane's action buttons (Send to FCA, Pass with reason)
 *
 * Width: 360px (matches desktop Inspector pane for visual continuity).
 * Opens from the right. Escape closes via shadcn Sheet default behaviour.
 * aria-label uses COCKPIT_LABELS.aria.inspector.
 *
 * Renders via InspectorPaneSlot — the SAME deal-vs-fallback branch CockpitLayout
 * uses for the desktop Inspector pane, so a non-deal work_type shows the same
 * "details available in preview" hint here that it shows at desktop width,
 * instead of an always-on DealInspectorPane that assumes deal-shaped payload.
 * Restored as part of the B1 fix — WI-NIGHT-CLOSE-UI-RESTORE-AND-AMNESTY-STAGGER-001
 * Leg B: the CEO's report that the rightmost pane disappears while narrowing the
 * window traced to this drawer being reachable for only one work_type (deal_screen)
 * before this fix; see InboxPreviewRouter.jsx's PreviewFrame trigger for the other half.
 *
 * Authority: WI-UI-CLEANUP-001 Stage 3, SA-2 §2.
 */

import React from 'react';
import {
  Sheet,
  SheetContent,
} from '@/components/ui/sheet';
import { COCKPIT_LABELS } from '@/config/task-display-config';
import { InspectorPaneSlot } from './InspectorPaneSlot';

export default function InspectorDrawer({ open, onOpenChange, selected, onRefresh }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        aria-label={COCKPIT_LABELS.aria.inspector}
        style={{ width: 360, padding: 0, overflow: 'hidden' }}
      >
        <InspectorPaneSlot selected={selected} onRefresh={onRefresh} />
      </SheetContent>
    </Sheet>
  );
}
